import '../styles/ListObject.css';
import { useState, useEffect, useCallback, useMemo } from "react";
import ObjectItem from '../components/ObjectItem';
import listServices from "../services/listServices";
import ListActionsMenu from '../components/ListObjectActionsMenu';
import { EditableObject } from '../bean/EditableObject';
import UrlImporter from '../components/UrlImporter';
import ObjectEditor from '../components/ObjectEditor';
import ObjectViewer from '../components/ObjectViewer';
import objectServices from "../services/objectServices";
import { isDemoKey } from "../services/kdoServices";
import reservationServices from "../services/ReservationServices";
/**
 * Component to render a list of objects.
 *
 * @param {Object} props - The component props.
 * @param {string} props.p_key - The key for the list object.
 * @param {Array} props.p_tabObject - The array of objects to be listed.
 * @param {Function} props.p_setTabOject - The function to set the tab object.
 * @returns {JSX.Element} The rendered component.
 */


function ListObject({ p_key, p_tabObject, p_setTabOject, p_isProprio, p_readonlyKey, p_user, p_listNames, p_setListNames, p_url = null, p_onGlobalCollapseChange }) {

  const [isURLImporterOpen, setIsURLImporterOpen] = useState(p_url!=null?true:false);
  const [showEditor, setShowEditor] = useState(false);
  const [editedObject, setEditedObject] = useState(null);
  const [idListActif, setIdListActif] = useState(null);
  const [isDataRegistering, setIsDataRegistering] = useState(false);
  const [isEditDetail, setisEditDetail] = useState(false);

  const HELP_LINKS = [ 
    { label: 'Créer ma première Liste', href: 'https://listaki.fr/aide/creer-liste' },
    { label: 'Ajouter mon premier article depuis un site marchand', href: 'https://listaki.fr/aide/ajouter-produit-automatique' },
    // { label: 'Ajouter mon premier article manuellement', href: 'https://listaki.fr/aide/ajout-produit-manuellement' }
  ];

  const v_readOnlyLink = window.location.origin + '?key=' + p_readonlyKey + '&idList=';

  const params = new URLSearchParams(window.location.search);
  const v_urlIdList = params.get('idList');
  // console.log("v_urlIdList : " + v_urlIdList);

  const [lightboxImg, setLightboxImg] = useState(null);
  const [collapsedLists, setCollapsedLists] = useState({});
  // console.log("lightboxImg", lightboxImg);

  const getListLabel = (idList) => {
    if (idList === null || idList === undefined) return "Sans Nom";
    const numericId = Number(idList);
    return p_listNames?.[numericId] || p_listNames?.[idList] || "Sans Nom";
  };


  async function editListeName(p_idList) {
    const v_newName = prompt("Nouveau nom de la liste", p_listNames[p_idList] || "Sans Nom");
    if (v_newName) {
      if (window.umami) window.umami.track('rename-Liste');
      const v_newList = await listServices.updateListName(p_key, p_idList, v_newName);
      if (v_newList) {
        p_setListNames({ ...p_listNames, [p_idList]: v_newName });
      }
    }
  }

  async function deleteList(p_idList) {
    const v_confirm = window.confirm("Êtes-vous sûr de vouloir supprimer cette liste ?");
    if (!v_confirm) return;

    try {
      if (window.umami) window.umami.track('delete-Liste');
        const result = await listServices.deleteRefList(p_key, p_idList);

        if (result?.success) {
            alert("Liste supprimée avec succès.");
            // Supprimer la liste localement
            const updatedListNames = { ...p_listNames };
            delete updatedListNames[p_idList];
            p_setListNames(updatedListNames);
        } else {
            const msg = result?.message || "Erreur inconnue lors de la suppression.";
            alert("Erreur : " + msg);
        }
    } catch (err) {
        alert("Erreur critique lors de la suppression : " + err.message);
        console.error(err);
    }
}


  async function onSave(p_EditableObject) {
    console.log(p_EditableObject);
    console.log(p_user);
    console.log(p_key);

    if (isDataRegistering) {
        console.log("Un enregistrement est déjà en cours, veuillez patienter...");
        return;
    }

    try{
      setIsDataRegistering(true);
    if (isDemoKey(p_key)) {
      alert("Mode démonstration, l'ajout n'est fait que dans cette session de démo, il disparaitra si vous rechargez de la page.")
      let v_objectName = p_EditableObject.title;
      if (v_objectName === null || v_objectName === '') {
        v_objectName = "Sans nom";
      }
      const now = new Date();
      const v_id = String(now.getHours()).padStart(2, "0") + String(now.getMinutes()).padStart(2, "0") + String(now.getSeconds()).padStart(2, "0");
      const updatedList = updateInList(p_tabObject, v_id, v_objectName, p_EditableObject.url, p_EditableObject.imagelinke, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList,p_EditableObject.affiliateLink);
      p_setTabOject(updatedList);
      setShowEditor(false);
    } else if (p_EditableObject.id) {
      const result = await objectServices.updateEditableObjectByKey(p_key, p_user, p_EditableObject);
      console.log("Modification de l'objet",result);
      const updatedList = updateInList(p_tabObject, p_EditableObject.id, p_EditableObject.title, p_EditableObject.url, p_EditableObject.imagelink, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList,result.affiliateLink);
      p_setTabOject(updatedList);
      setShowEditor(false);
    } else {
      console.log("Création de l'objet en base", p_EditableObject);
      const result = await objectServices.addEditableObjectByKey(p_key, p_user, p_EditableObject);
      console.log("creation de l'objet : ", result);
      const updatedList = updateInList(p_tabObject, result.id, p_EditableObject.title, p_EditableObject.url, p_EditableObject.imagelink, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList,result.affiliateLink);
      p_setTabOject(updatedList);
      setShowEditor(false);
    }
    } catch (err) {
      console.log("Erreur lors de l'enregistrement : " + err.message);
      console.error(err);
    }
    finally {
      setIsDataRegistering(false);
    }
  };

  function updateInList(tabObject, p_id, p_name, p_link, p_image, p_price, p_description, p_storeName, p_idList,p_affiliateLink) {
    const getFormattedDate = () => {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
    };

    const exists = tabObject.find(obj => obj.id === p_id);

    if (exists) {
      const updatedList = tabObject.map(obj =>
        obj.id === p_id
          ? {
            ...obj,
            objectname: p_name,
            urllink: p_link,
            imagelink: p_image,
            price: p_price,
            description: p_description,
            storeName: p_storeName,
            affiliateLink: p_affiliateLink,
            idList: Number(p_idList)
          }
          : obj
      );
      return updatedList;
    } else {
      const newObject = {
        id: p_id,
        objectname: p_name,
        urllink: p_link,
        imagelink: p_image,
        price: p_price,
        description: p_description,
        datecreation: getFormattedDate(),
        storeName: p_storeName,
        affiliateLink: p_affiliateLink,
        idList: Number(p_idList) // Important si idList est une chaîne de caractères "8" alors que le filtre dans le rendu fait .filter((product) => product.idList === Number(idlist)) alors ca ne fonctionne pas
      };
      console.log("newObject : ", newObject);
      return [...tabObject, newObject];
    }
  }

  const onReserveByOwner = async (p_id) => {

    const v_idreserv = reservationServices.registerReservation(p_key, "Moi", "me@me.com", p_id,setIsDataRegistering);
    const exists = p_tabObject.find(obj => obj.id === p_id);

    if (exists) {
      p_setTabOject(p_tabObject.map(obj =>
        obj.id === p_id
          ? {
            ...obj,
            reservationid: v_idreserv,
          }
          : obj
      ));
    }
    setShowEditor(false);
        // const tmpKey = Date.now();
        // const requestOptions = {
        //     method: "POST",
        //     mode: 'cors',
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify({
        //         email: "me",
        //         name : "me",
        //         idObject : p_id
        //     }),
        // };

        // try {
        //     const response = await fetch("https://app.listaki.fr/api/WS/reservation.php?key=" + p_key, requestOptions);
        //     const data = await response.json();
        //     if (response.ok && data?.success) {
        //         alert("Article réservé avec succès.");
        //     } else {
        //         alert(data?.error || "Erreur lors de la réservation.");
        //     }
        // } catch (e) {
        //     console.error(e);
        //     alert("Erreur réseau lors de la réservation.");
        // }
    };

  const handleReservationUpdate = useCallback((objectId, reservationId) => {
    if (!objectId) return;
    p_setTabOject((prev) =>
      prev.map((obj) =>
        obj.id === objectId ? { ...obj, reservationid: reservationId } : obj
      )
    );
    setEditedObject((prev) => {
      if (!prev || prev.id !== objectId) return prev;
      return new EditableObject({ ...prev, reservationid: reservationId });
    });
  }, [p_setTabOject]);

  // function updateInList(p_id, p_name, p_link, p_image, p_price, p_description, p_storeName, p_idList) {
  //   const getFormattedDate = () => {
  //     const now = new Date();
  //     const year = now.getFullYear();
  //     const month = String(now.getMonth() + 1).padStart(2, "0");
  //     const day = String(now.getDate()).padStart(2, "0");
  //     const hours = String(now.getHours()).padStart(2, "0");
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const seconds = String(now.getSeconds()).padStart(2, "0");

  //     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   };

  //   // Rechercher l'élément existant par ID
  //   const currentElement = p_tabObject.find(obj => obj.id === p_id);
  //   if (currentElement) {
  //     console.log("currentElement.description : " + currentElement.description + ", " + p_description);
  //     // Si un élément existe, supprimer l'ancienne entrée
  //     p_tabObject = p_tabObject.filter(obj => obj.id !== p_id);
  //     // Créer la nouvelle version de l'élément
  //     const updatedElement = {
  //       ...currentElement,
  //       objectname: p_name,
  //       urllink: p_link,
  //       imagelink: p_image,
  //       price: p_price,
  //       description: p_description,
  //       storeName: p_storeName,
  //       idList: p_idList
  //     };

  //     console.log("updatedElement.description : " + updatedElement.description);
  //     // Ajouter l'élément mis à jour
  //     return [...p_tabObject, updatedElement];
  //   } else {
  //     // Si aucun élément n'a été trouvé, ajouter un nouvel élément
  //     const newElement = {
  //       id: p_id,
  //       objectname: p_name,
  //       urllink: p_link,
  //       imagelink: p_image,
  //       price: p_price,
  //       description: p_description,
  //       datecreation: getFormattedDate(),
  //       storeName: p_storeName,
  //       idList: p_idList
  //     };

  //     return [...p_tabObject, newElement];
  //   }
  // }

  const onEditobject = useCallback((p_id) => {
    const v_object = p_tabObject.find(obj => obj.id === p_id);
    if (v_object) {
      const editableObj = EditableObject.fromDBObject(v_object);
      setEditedObject(editableObj);
      setisEditDetail(true);
      setShowEditor(true);
    } else {
      console.error("Objet non trouvé pour l'ID :", p_id);
    }
  }, [p_tabObject]);

  const onDetailobject = useCallback((p_id) => {
    const v_object = p_tabObject.find(obj => obj.id === p_id);
    if (v_object) {
      const editableObj = EditableObject.fromDBObject(v_object);
      setEditedObject(editableObj);
      setisEditDetail(false);
      setShowEditor(true);
    } else {
      console.error("Objet non trouvé pour l'ID :", p_id);
    }
  }, [p_tabObject]);

  const toggleListCollapse = (listId) => {
    setCollapsedLists((prev) => ({
      ...prev,
      [listId]: !prev?.[listId],
    }));
  };

  const setAllListsCollapsed = (shouldCollapse) => {
    if (!p_listNames) {
      setCollapsedLists({});
      return;
    }
    if (shouldCollapse) {
      const nextState = {};
      Object.keys(p_listNames).forEach((id) => {
        nextState[id] = true;
      });
      setCollapsedLists(nextState);
    } else {
      setCollapsedLists({});
    }
  };

  const { listIds, hasLists, areAllCollapsed } = useMemo(() => {
    const ids = Object.keys(p_listNames || {});
    const has = ids.length > 0;
    const allCollapsed = has && ids.every((id) => collapsedLists[id]);
    return { listIds: ids, hasLists: has, areAllCollapsed: allCollapsed };
  }, [p_listNames, collapsedLists]);
  const currentViewerListName = editedObject ? getListLabel(editedObject.idList) : "Sans Nom";

  useEffect(() => {
    if (typeof p_onGlobalCollapseChange !== "function") {
      return;
    }
    if (hasLists) {
      p_onGlobalCollapseChange({
        hasLists: true,
        isCollapsed: areAllCollapsed,
        toggle: () => setAllListsCollapsed(!areAllCollapsed),
      });
    } else {
      p_onGlobalCollapseChange(null);
    }
  }, [p_onGlobalCollapseChange, hasLists, areAllCollapsed]);

  useEffect(() => {
    return () => {
      if (typeof p_onGlobalCollapseChange === "function") {
        p_onGlobalCollapseChange(null);
      }
    };
  }, [p_onGlobalCollapseChange]);

  return (
    <div className="kdo_lo">
      {lightboxImg && (
        <div className="kdo-lo-img-lightbox" onClick={() => setLightboxImg(null)}>
          <span className="kdo-lo-img-lightbox-close" onClick={() => setLightboxImg(null)}>&times;</span>
          <img src={lightboxImg} alt="Agrandissement" />
        </div>
      )}
      <div className="kdo_lo_listobject">
        {/* {true==true? ( */}
        {Object.entries(p_listNames)
            .filter(([id, name]) => (v_urlIdList ? Number(id) === Number(v_urlIdList) : true))
            .map(([idlist, name], index) => {
              const listLabel = idlist ? (p_listNames[idlist] || "Chargement...") : "Sans Nom";
              const isListCollapsed = !!collapsedLists[idlist];
              const panelId = `kdo-lo-panel-${idlist}`;
              const toggleLabel = `${isListCollapsed ? "Agrandir" : "Réduire"} la liste ${listLabel}`;
              return (
              <div key={index} className="kdo_lo_listobject">
                <hr className="kdo_lo_separator" />
                <div className="kdo_lo_listheader">
                  <button
                    type="button"
                    className={`kdo_lo_toggle ${isListCollapsed ? "collapsed" : ""}`}
                    aria-expanded={!isListCollapsed}
                    aria-controls={panelId}
                    onClick={() => toggleListCollapse(idlist)}
                    title={toggleLabel}
                    aria-label={toggleLabel}
                  >
                    <span className="kdo_lo_chevron" aria-hidden="true" />
                  </button>
                  <span className="kdo_lo_listname">
                    Liste : {listLabel}
                    {idlist && p_isProprio ? (
                      <>
                        <ListActionsMenu
                          onRename={() => editListeName(Number(idlist))}
                          onShare={() => {                              
                            if (window.umami) window.umami.track('share-Liste');
                            navigator.clipboard.writeText(v_readOnlyLink + idlist);
                            alert("Lien de partage copié !");
                          }}
                          onDelete={() => {
                            deleteList(Number(idlist));
                          }}
                        />
                        {/* &nbsp;
                        <img src={logo} className="kdo_lo_editlogo" onClick={editListeName(idlist)} />
                        <Partage p_link={v_readOnlyLink+idlist} p_idList={idlist}/> */}
                      </>
                    ) : (null)}
                  </span>
                </div>
                {!isListCollapsed && (
                  <div className="kdo_lo_objects" id={panelId}>
                  {
                    p_tabObject
                      .filter((product) => product.idList === Number(idlist)) // Filtre les objets avec le bon idList
                      .map((product) => (
                        <ObjectItem
                          key={product.id}
                          p_key={p_key}
                          p_object={product}
                          p_tabObject={p_tabObject}
                          p_setTabObject={p_setTabOject}
                          p_isProprio={p_isProprio}
                          p_user={p_user}
                          p_setLightboxImg={setLightboxImg}
                          p_onEditObject={onEditobject}
                          p_onDetailObject={onDetailobject}
                          p_onReserved={handleReservationUpdate}
                        />
                      ))
                  }

                  {isURLImporterOpen && (
                    <UrlImporter
                      isOpen={isURLImporterOpen}
                      onClose={() => setIsURLImporterOpen(false)}
                      onResult={(result) => {
                        if (result) {
                          const editableObj = EditableObject.fromImportedObject(result);
                          editableObj.idList = idListActif;
                          setEditedObject(editableObj);
                          setIsURLImporterOpen(false);
                          setisEditDetail(true);
                          setShowEditor(true);
                        }
                      }}
                      onManualEdit={() => {
                        const editableObj = new EditableObject();
                        editableObj.idList = idListActif;
                        setEditedObject(editableObj);
                        setisEditDetail(true);
                        setShowEditor(true);
                      }}
                      p_url={p_url}
                    />
                  )}
                  {p_isProprio && !isURLImporterOpen && (
                    <button className="kdo-object kdo-add-tile"
                      onClick={() => {
                        setIdListActif(idlist);        // capture l'id courant
                        setIsURLImporterOpen(true);    // ouvre la modale
                      }} aria-label="Ajouter un article">
                      <span className="kdo-add-icon">+</span>
                    </button>
                  )}

                  {showEditor && (
                    p_isProprio && isEditDetail ? (
                      <ObjectEditor
                        object={editedObject}
                        onCancel={() => setShowEditor(false)}
                        onSave={(updatedObject) => onSave(updatedObject)}
                        readonly={!p_isProprio}
                        isDaataRegistering={isDataRegistering}
                        onReserveByOwner={() => onReserveByOwner(editedObject.id)}
                        p_setLightboxImg={setLightboxImg}
                      />
                    ) : (
                      <ObjectViewer
                        object={editedObject}
                        listName={currentViewerListName}
                        onClose={() => setShowEditor(false)}
                        p_setLightboxImg={setLightboxImg}
                        p_isProprio={p_isProprio}
                        p_key={p_key}
                        p_onReserved={handleReservationUpdate}
                      />
                    )
                  )}

                  </div>
                )}
              </div>
            )})
          // ) : (
          //   <p>Vous n'avez rien dans votre liste!</p>
          //   )
        }
        {p_tabObject
          .filter((product) => product.idList === null).length > 0 ?
          <div>
            <hr className="kdo_lo_separator" />
            <span className="kdo_lo_listname">
              Liste : Sans Nom
            </span>
            {
              p_tabObject
                .filter((product) => product.idList === null) // Filtre les objets avec le bon idList
                .map((product) => (
                  <ObjectItem
                    key={product.id}
                    p_key={p_key}
                    p_object={product}
                    p_tabObject={p_tabObject}
                    p_setTabObject={p_setTabOject}
                    p_isProprio={p_isProprio}
                    p_user={p_user}
                    p_setLightboxImg={setLightboxImg}
                    p_onEditObject={onEditobject}
                    p_onDetailObject={onDetailobject}
                    p_onReserved={handleReservationUpdate}
                  />
                ))
            }
          </div>
          : null}
      </div>

      {p_tabObject.length === 0 && (
    <div className="kdo-help-card" role="note">
      <div className="kdo-help-card__icon" aria-hidden="true">?</div>
      <div className="kdo-help-card__content">
        <p className="kdo-help-card__title">Besoin d'un coup de main ?</p>
        <p className="kdo-help-card__subtitle">Retrouver toute l'aide dans : Menu > Aide.</p>
        <p className="kdo-help-card__subtitle">Quelques ressources pour vous aider à démarrer :</p>
        <ul className="kdo-help-card__links">
          {HELP_LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href} target="_blank" rel="noreferrer">
                {link.label} <span aria-hidden="true">&rarr;</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>)}

    </div>
  );

}

export default ListObject;


